<page-title [title]="titles[0]"></page-title>
<p>Mantenha seus dados atualizados.</p>

<page-alert *ngIf="alerts.length > 0 && showWarningMessage" [message]="messageWarning">
</page-alert>

<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Perfil">
    <ng-template mat-tab-label>
      <span>
        Perfil
      </span>
    </ng-template>
    <ng-template matTabContent>
      <secretary-registration (onUpdateSecretary)="setSecretary($event)" mode="UPDATE"> </secretary-registration>
    </ng-template>


  </mat-tab>

  <mat-tab label="Localização" [disabled]="checkIfIsFirstAccess()">
    <ng-template mat-tab-label>
      <span [matTooltip]="checkIfIsFirstAccess() ? 'Complete o cadastro do perfil para liberar esta aba' : ''">
        Localização
      </span>

    </ng-template>
    <ng-template matTabContent>
      <secretary-address-form (onUpdateSecretary)="setSecretary($event)" mode="UPDATE">
      </secretary-address-form>
    </ng-template>


  </mat-tab>


  <mat-tab label="Qualificações" [disabled]="checkIfIsFirstAccess()">

    <ng-template mat-tab-label>
      <span [matTooltip]="checkIfIsFirstAccess() ? 'Complete o cadastro do perfil para liberar esta aba' : ''">
        Qualificações
      </span>
    </ng-template>
    <ng-template matTabContent>
      <secretary-qualification-form (onUpdateSecretary)="setSecretary($event)"
        mode="UPDATE"></secretary-qualification-form>
    </ng-template>


  </mat-tab>

</mat-tab-group>